import { useState, useEffect } from 'react';
import FilterField from '../../LoadFilters/FilterField';
import { getMinDate, getMaxDate, hasAnyFilterSelected } from '../../LoadFilters/utils';
import { getUnmatchedDeclarationsLazyStatuses } from '../../../api/declarations';
import PropTypes from 'prop-types';

const styles = {
  fields: 'd-flex gap-4 justify-content-between',
  column: 'd-flex flex-column gap-2 flex-grow-1',
  dateField: 'd-flex gap-2',
};

const UnmatchedDeclarationsFilters = ({ visible, values, onChange, onSubmit }) => {
  const [statusOptions, setStatusOptions] = useState([]);

  useEffect(() => {
    if (visible && statusOptions.length === 0) {
      getUnmatchedDeclarationsLazyStatuses().then((data) => {
        const opts = Array.isArray(data) ? data : (data?.data ?? []);
        setStatusOptions(
          opts
            .filter((o) => (o.data ?? o.id) != null)
            .map((o) => ({ id: o.id ?? o.data, data: o.data ?? String(o.id) }))
        );
      });
    }
  }, [visible]);

  const handleChange = (e) => {
    onChange((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  if (!visible) return null;

  return (
    <div className="px-3 mt-4">
      <div className={styles.fields}>
        <div className={styles.column}>
          <FilterField label="LRN" field="LRN" value={values.LRN} onChange={handleChange} />
          <FilterField label="MRN" field="MRN" value={values.MRN} onChange={handleChange} />
          <FilterField
            label="STATUS"
            field="declarationStatus"
            value={values.declarationStatus}
            options={statusOptions}
            onChange={handleChange}
          />
        </div>
        <div className={styles.column}>
          <div className={styles.dateField}>
            <FilterField
              type="date"
              label="DECLARATIONS DATE"
              field="createdDateFrom"
              value={values.createdDateFrom}
              onChange={handleChange}
              min={values.createdDateTo ? getMinDate(values.createdDateTo) : undefined}
              max={values.createdDateTo || undefined}
            />
            <FilterField
              type="date"
              field="createdDateTo"
              value={values.createdDateTo}
              onChange={handleChange}
              min={values.createdDateFrom || undefined}
              max={values.createdDateFrom ? getMaxDate(values.createdDateFrom) : undefined}
            />
          </div>
        </div>
      </div>
      <div className="text-end mb-3">
        <button className="stepper-button yellow" onClick={onSubmit} disabled={!hasAnyFilterSelected(values)}>
          Apply Filter
        </button>
      </div>
    </div>
  );
};

UnmatchedDeclarationsFilters.propTypes = {
  visible: PropTypes.bool,
  values: PropTypes.shape({
    LRN: PropTypes.string,
    MRN: PropTypes.string,
    declarationStatus: PropTypes.string,
    createdDateFrom: PropTypes.string,
    createdDateTo: PropTypes.string,
  }),
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default UnmatchedDeclarationsFilters;
